import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TToastData = {
    type: string;
    text: string;
    show: boolean;
};

const initialState = {
    type: "",
    text: "",
    show: false,
};

const toastData = createSlice({
    name: "toastData",
    initialState,
    reducers: {
        updateToastData: (state, action: PayloadAction<TToastData>) => {
            const { text, type, show } = action.payload;
            state.text = text;
            state.type = type;
            state.show = show;
        },
    },
});

export const { updateToastData } = toastData.actions;
export default toastData.reducer;
